import React from "react";
import { FaLaptopCode, FaMobileAlt, FaCloud, FaSearch, FaShoppingCart, FaPaintBrush } from "react-icons/fa";

const servicesData = [
  {
    icon: <FaLaptopCode size={40} color="#FF6B6B" />,
    title: "Web Development",
    description: "Responsive, modern websites with clean UI/UX design.",
  },
  {
    icon: <FaMobileAlt size={40} color="#FFD93D" />,
    title: "Mobile Apps",
    description: "Cross-platform mobile solutions for Android and iOS.",
  },
  {
    icon: <FaCloud size={40} color="#6BCB77" />,
    title: "Cloud Solutions",
    description: "Scalable and secure cloud infrastructure setup.",
  },
  {
    icon: <FaSearch size={40} color="#4D96FF" />,
    title: "SEO Optimization",
    description: "Improve your website visibility and rank higher in search results.",
  },
  {
    icon: <FaShoppingCart size={40} color="#FF6AC1" />,
    title: "E-commerce Solutions",
    description: "Custom online stores with payment integration and analytics.",
  },
  {
    icon: <FaPaintBrush size={40} color="#FFA500" />,
    title: "UI/UX Design",
    description: "Engaging, user-friendly interfaces for web and mobile apps.",
  },
];

const Services = React.forwardRef((props, ref) => (
  <section
    ref={ref}
    style={{
      minHeight: "100vh",
      padding: "4rem 2rem",
      background: "linear-gradient(to right, #fff8f0, #f0f0f0)",
    }}
  >
    <h2
      className="text-3xl md:text-4xl font-extrabold text-center mb-8"
      style={{
        color: "#8B4513",
        textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
        animation: "fadeIn 1s ease-in-out",
      }}
    >
      Our Services
    </h2>

    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "2rem",
      }}
    >
      {servicesData.map((service, index) => (
        <div
          key={index}
          className="service-card"
          style={{
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "10px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            maxWidth: "300px",
            textAlign: "center",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            animation: `fadeInUp 0.6s ease forwards`,
            animationDelay: `${index * 0.2}s`,
            opacity: 0,
          }}
        >
          <div style={{ marginBottom: "1rem" }}>{service.icon}</div>
          <h3 style={{ color: "#8B4513", fontWeight: "bold", marginBottom: "0.5rem" }}>
            {service.title}
          </h3>
          <p style={{ color: "#555" }}>{service.description}</p>
        </div>
      ))}
    </div>

    <style>
      {`
        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(20px);}
          100% { opacity: 1; transform: translateY(0);}
        }

        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); opacity: 1; }
        }

        .service-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }
      `}
    </style>
  </section>
));

export default Services;
